import { Mapper } from 'src/base/mapper'
import { MenuItemTypeEntity } from 'src/data/entities/component.entity'
import { MenuItemTypeModel } from 'src/domain/models/component.model'

export class MenuItemMapper extends Mapper<MenuItemTypeEntity, MenuItemTypeModel> {
	mapFrom(param: MenuItemTypeEntity): MenuItemTypeModel {
		return {
			label: param.label,
			functionCode: param.functionCode,
			functionCaption: param.functionCaption,
			path: param.path,
			icon: param.icon,
			isActive: null,
			isDelete: null,
			enableForRole: param.enableForRole,
			absoluteUrl: null,
		}
	}

	mapTo(param: MenuItemTypeModel): MenuItemTypeEntity {
		return {
			screenSequence: null,
			label: param.label,
			functionCode: param.functionCode,
			functionCaption: param.functionCaption,
			path: param.path,
			icon: param.icon,
			enableForRole: param.enableForRole,
		}
	}
}
